import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Text } from '@clariness/clarikit-react';

export const OrSeparator = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="10px"
      width="100%"
      margin="10px 0"
    >
      <Box
        as="span"
        aria-hidden="true"
        height="1px"
        backgroundColor="color-gray-variant-4"
        style={{ flex: 1 }}
      />
      <Text as="span" variant="bodyMd">
        <FormattedMessage id="is.login.or_separator" defaultMessage="Or" />
      </Text>
      <Box
        as="span"
        aria-hidden="true"
        height="1px"
        backgroundColor="color-gray-variant-4"
        style={{ flex: 1 }}
      />
    </Box>
  );
};
